import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

export const WindowContext = React.createContext({
  clientHeight: 0,
  clientWidth: 0,
})

export const WindowContextProvider = ({ children }) => {
  const getClientDimensions = () => ({
    clientHeight: document.documentElement.clientHeight || 0,
    clientWidth: document.documentElement.clientWidth || 0,
  })

  const [dimensions, setDimensions] = useState(getClientDimensions)

  const handleResize = useCallback(() => {
    setDimensions(getClientDimensions())
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])

  return (
    <WindowContext.Provider value={dimensions}>
      {children}
    </WindowContext.Provider>
  )
}

WindowContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
